module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAA8klEQVR4Ae3UP0rHQBBH8Yd7DqPxUjERS0GrQM4i9tEtvIitN4h/DmEjyy9ChAyyhNXsDFjsd/rPIxCWf7GysppnPrnDYbIz3pmX8zgzXivh8DQxr5VwPDITaGJeJ+EX4DshfHy37FxDWBOD8NF9QGYicU9kbEjyE8eZP2WCryg8I9ccdPn6B38EXHGw5IkSvTYPcCMBAueavLxMcoE2j7/f5CXR/ZV/S/NM9IT1Gw34CmgJ8lDr8wAd417+IcHv2Omv+JfCe30eax5rXgKXm/wJaAQCrTIvAUno8hKQxIXwvCrwEpDT5bHmsebR4PVXVvYFEVLJV0ZEiSEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colorpicker.png
// module id = 495
// module chunks = 0